var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"nav nav-tabs nav-tabs-fillup offer"},_vm._l((_vm.tabs),function(tab){return _c('li',{class:[{'active': _vm.current === tab},'item'],on:{"click":function($event){return _vm.changeTab(tab)}}},[_c('a',[_c('span',[_vm._v(_vm._s(tab.title))])])])}),0),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f2227de","hasScoped":false,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Catalog/CatalogTabs.vue
// module id = 1860
// module chunks = 0